var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8287 17.0747C27.8008 18.5632 31.4491 23.8367 30.2658 33.0228C31.111 33.9443 32.7168 36.5102 32.3787 39.4021C31.3223 38.0554 28.9558 35.9148 27.9417 38.1262C28.2473 40.6713 29.0026 44.1874 30.3242 47.4598C30.8143 46.943 31.5075 46.6207 32.276 46.6207C33.5503 46.6207 34.6176 47.5069 34.8953 48.6965C35.1743 48.5176 35.5061 48.4138 35.8622 48.4138C36.5439 48.4138 37.1368 48.7942 37.4401 49.3544C46.0636 45.1222 52 36.2544 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 35.836 5.46182 44.3963 13.518 48.8135C13.7335 48.0649 14.4235 47.5172 15.2414 47.5172C15.7187 47.5172 16.1525 47.7038 16.4738 48.0079C16.9325 47.1807 17.8147 46.6207 18.8276 46.6207C19.9028 46.6207 20.8307 47.2516 21.2612 48.1634C22.3695 45.6018 23.3089 42.3141 23.9271 38.1262C23.575 37.2048 22.1946 36.1699 19.4901 39.4021C19.2788 38.4806 19.4056 35.9148 21.603 33.0228C21.11 29.4788 21.2648 21.3275 25.8287 17.0747Z",
    fill: "#004FA4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.db565185c569595729cdf819beb82438.svg";
export { ForwardRef as ReactComponent };